import { render, staticRenderFns } from "./RedesSociais.vue?vue&type=template&id=29f34b5c"
import script from "./RedesSociais.vue?vue&type=script&lang=js"
export * from "./RedesSociais.vue?vue&type=script&lang=js"
import style0 from "./RedesSociais.vue?vue&type=style&index=0&id=29f34b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports